var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import ReactHtmlParser from '@pcty/react-html-parser-fork';
import { at, isNilOrEmpty, isNotNilOrEmpty } from '@pcty/utils';
import { getAutomation } from '@citrus/runtime';
import { Highlight } from './Highlighter.styled';
import { useHighlighter } from './HighlighterContext';
import { getConfig } from './private/utils';
var FuzzyHighlighter = function (_a) {
    var _b, _c, _d;
    var automationId = _a.automationId, className = _a.className, css = _a.css, disabled = _a.disabled, _indexes = _a.indexes, text = _a.text, _e = _a.__TYPE, TYPE = _e === void 0 ? 'FuzzyHighlighter' : _e, other = __rest(_a, ["automationId", "className", "css", "disabled", "indexes", "text", "__TYPE"]);
    var context = (_b = useHighlighter()) !== null && _b !== void 0 ? _b : {};
    var config = getConfig(context, {
        automationId: automationId,
        className: className,
        css: css,
        disabled: disabled,
        targetIndexMap: isNotNilOrEmpty(_indexes) ? new Map([[text, _indexes]]) : undefined,
        text: text,
    });
    if (config.disabled)
        return React.createElement(React.Fragment, null, text);
    var indexes = (_d = (_c = config.fuzzyTargetIndexMap) === null || _c === void 0 ? void 0 : _c.get(text)) !== null && _d !== void 0 ? _d : [];
    if (isNilOrEmpty(indexes))
        return React.createElement(React.Fragment, null, text);
    var identifier = new Date().getTime().toString();
    for (var i = indexes.length - 1; i >= 0; i--) {
        var range = indexes[i];
        var slice = text.slice(at(range, 0, 0), at(range, 1, 1) + 1);
        var start = text.slice(0, at(range, 0, 0));
        var end = text.slice(at(range, 1, 0) + 1);
        text = "".concat(start, "<span class=\"").concat(identifier, "\">").concat(slice, "</span>").concat(end);
    }
    return (React.createElement(React.Fragment, null, React.Children.toArray(ReactHtmlParser(text)).map(function (node, index) {
        var _a;
        return ((_a = node === null || node === void 0 ? void 0 : node.props) === null || _a === void 0 ? void 0 : _a.className) === identifier ? (React.createElement(Highlight, __assign({}, other, (config.automationId ? getAutomation(config.automationId) : {}), { className: config.className, css: config.css, key: node.props.children + index }), node.props.children)) : (node);
    })));
};
FuzzyHighlighter.defaultProps = {
    __TYPE: 'FuzzyHighlighter',
};
export default FuzzyHighlighter;
